/* eslint-disable no-shadow */
enum ReservationProcessStep {
  FirstPage = 0,
  FinalizationPage = 1,
}

export default ReservationProcessStep;
